import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { usePeriod } from '@/pages/reports/PeriodContext.tsx';
import transactionService from "@transactionService";

/**
 * Fetch transaction breakdown by type
 * @param {CashFlowType} type
 */
export function useFetchTransactionBreakdownByType(type: CashFlowType) {
  const { user } = useAuth();
  const { period } = usePeriod();

  return useQuery({
    queryKey: ['category-breakdown', user?.id, type, period.dateFrom, period.dateTo],
    queryFn: async (): Promise<CategoryBreakdown[]> => {
      return await transactionService.fetchTransactionBreakdownByType(user.id, type, period);
    },
    enabled: !!user,
  });
}
